module.exports = __webpack_public_path__ + "img/wf-finishing-position-16.97f9ade4.svg";